import { apiClient } from './api';

export interface LeagueSettings {
  name: string; slug: string; timezone: string; startsAt: string; endsAt: string;
  registrationDeadline: string; capacity: number; ntrpMin: number; ntrpMax: number;
  matchFormat: string; thirdPlace: boolean; prizes: string; prizeDelivery: string;
  sponsor: string; contact: string;
}
export interface LeagueEvent {
  competitionPublicId: string; status: string; version: number; joinCode: string;
  settings: LeagueSettings; rulesText: string; registrationState?: string;
  amendments: { reason: string; at: string; version: number }[];
}
export interface LeagueRequest { clientMutationId: string; expectedVersion?: number; settings: LeagueSettings; amendmentReason?: string }
const studio='/api/v1/web/organizer/leagues';
export const leagueEvents={
  async list():Promise<LeagueEvent[]>{return (await apiClient.get(studio)).data;},
  async get(id:string):Promise<LeagueEvent>{return (await apiClient.get(`${studio}/${encodeURIComponent(id)}`)).data;},
  async create(request:LeagueRequest):Promise<LeagueEvent>{return (await apiClient.post(studio,request)).data;},
  async save(id:string,request:LeagueRequest,amendment:boolean):Promise<LeagueEvent>{return (await (amendment?apiClient.post(`${studio}/${id}/amendments`,request):apiClient.put(`${studio}/${id}`,request))).data;},
  async publish(id:string,expectedVersion:number):Promise<LeagueEvent>{return (await apiClient.post(`${studio}/${id}/publish`,{expectedVersion})).data;},
  async publicEvent(slug:string):Promise<LeagueEvent>{return (await apiClient.get(`/api/v1/public/leagues/${encodeURIComponent(slug)}`)).data;},
};
export function leagueError(error:unknown):string {
  const code=(error as {response?:{data?:{error?:string;errorCode?:string;code?:string}}})?.response?.data;
  switch(code?.error||code?.errorCode||code?.code){
    case 'ORGANIZER_EVENT_QUOTA_EXHAUSTED':return 'No free events remaining. Ask TARK for an additional event allowance.';
    case 'ORGANIZER_APPROVAL_REQUIRED':return 'An active, approved Organizer is required to publish.';
    case 'LEAGUE_VERSION_CONFLICT':return 'The event changed. Reload before saving.';
    case 'LEAGUE_RULES_FROZEN':return 'Registration is open. Use a rules amendment with a reason.';
    case 'LEAGUE_FIELDS_LOCKED':return 'After the first entry, competitive rules are locked. Text changes and date extensions are allowed.';
    case 'LEAGUE_IDENTITY_LOCKED':return 'The event identity cannot be changed.';
    case 'LEAGUE_JOIN_CODE_BUSY':return 'Could not reserve a join code. Try again.';
    case 'LEAGUE_SLUG_TAKEN':return 'That public slug is already used. Choose another.';
    default:return 'Could not save the event. Check its details and try again.';
  }
}
